import React from 'react';
import type { PresentationSDKT } from '@mentimeter/question-modules-types';
import type { Slide } from '@core-api/presentation/types/response';

export type PresentationContextSlide = Pick<
  Slide,
  | 'slideAdminKey'
  | 'slidePublicKey'
  | 'title'
  | 'staticContent'
  | 'interactiveContents'
  | 'images'
  | 'responseVisibility'
  | 'design'
>;

export const PresentationContext = React.createContext<{
  sdk: PresentationSDKT | null;
  presentationSlide: PresentationContextSlide | null;
}>({ sdk: null, presentationSlide: null });
PresentationContext.displayName = 'QuestionModulesPresentationContext';

export function usePresentationContext() {
  const context = React.useContext(PresentationContext);
  if (!context || !context.sdk) {
    throw new Error(
      'Trying to use presentation context before it is set or without adding a provider.',
    );
  }

  return context.sdk;
}

export function usePresentationSlideContext() {
  const context = React.useContext(PresentationContext);
  if (!context || !context.presentationSlide) {
    throw new Error(
      'Trying to use presentation context before it is set or without adding a provider.',
    );
  }

  return context.presentationSlide;
}
